/**
 * Global Configuration for the Orbifert Organic Frontend.
 * Points to the live deployed backend API service.
 */
export const API_BASE_URL = 'https://backend.orbifertorganic.com/api';
